export default __webpack_public_path__ + "784c3c73e9bfc447cb3906bfc7ac2cd5.png";